var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.paramsData.id !== "" ? "修改" : "新增",
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData(true)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "label", label: "角色ID" }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1 no-number",
                    attrs: { placeholder: "请输入角色ID" },
                    model: {
                      value: _vm.paramsData.label,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "label", _vm._n($$v))
                      },
                      expression: "paramsData.label"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "label", label: "设备ID" }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1 no-number",
                    attrs: { placeholder: "请输入设备ID" },
                    model: {
                      value: _vm.paramsData.label,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "label", _vm._n($$v))
                      },
                      expression: "paramsData.label"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { label: "IP" } },
                [
                  _c("el-input", {
                    staticClass: "flex-1 no-number",
                    attrs: { placeholder: "请输入IP" },
                    model: {
                      value: _vm.paramsData.label,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "label", _vm._n($$v))
                      },
                      expression: "paramsData.label"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogShow = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v("重置")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }